// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { Handler, HasOnError } from "@insite/client-framework/HandlerCreator";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import {
    chain,
    WaitForData,
} from "@insite/client-framework/Store/Pages/OrderConfirmation/Handlers/PreloadOrderConfirmationData";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<
    {
        cartId: string;
        onSuccess: () => void;
    } & HasOnError<string>
>;

export const WaitForLinkedData: HandlerType = async props => {
    const checkData = () => {
        const state = props.getState();
        const cartState = getCartState(state, props.parameter.cartId);

        if (cartState.value && cartState.value.properties.linkedCarts) {
            const linkedCart = getCartState(state, cartState.value.properties.linkedCarts);
            if (!linkedCart.value && !linkedCart.isLoading) {
                props.dispatch(loadCart({ cartId: cartState.value.properties.linkedCarts }));
                return false;
            }

            if (!linkedCart.value) {
                return false;
            }
        }

        return true;
    };

    await waitFor(checkData);
};

addToChainAfter(chain, WaitForData, WaitForLinkedData);
